import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import { Col, Container, Row, Button, Alert } from "react-bootstrap";
// eslint-disable-next-line no-unused-vars
import { Link } from "react-router-dom";
import "../../Style.css";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Api from "../../components/api/Api";
import { useSelector } from "react-redux";
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
// eslint-disable-next-line no-unused-vars
import AllMessage from "../../../components/common/allMessage/AllMessage";
import Select from "react-select";
import Tr from "../../components/tr/Tr";
const City = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  // eslint-disable-next-line no-unused-vars
  const userId = loggedInUser?.user?.id;
  const token = loggedInUser?.refreshToken;
  // eslint-disable-next-line no-unused-vars
  const [selectedCountry, setSelectedCity] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  console.log(selectedState);
  const cityApi = Api({
    url: `admin/cities/${selectedState?.value}`,
  });
  const stateApi = Api({
    url: `admin/states/${1}`,
  });

  // eslint-disable-next-line no-unused-vars
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const handleDeleteAlertClose = () => setShowDeleteAlert(false);
  // eslint-disable-next-line no-unused-vars
  const handleDeleteAlertShow = () => setShowDeleteAlert(true);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/admin/deleteCity/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.statusType === "SUCCESS") {
        setData(data.filter((item) => item.id !== itemId));
        showToast("City deleted successfully", {
          type: "success",
        });
      } else {
        console.error(
          "Error 'deleting' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error 'deleting' item:", error);
    }
  };
  const [data, setData] = useState([]);
  const [statedata, setStateData] = useState([]);
  const columns = [
    { displayName: "S.No.", render: (item, index) => ((currentPage-1)*10) + index + 1 },
    { displayName: "Name", key: "name" },
  ];
  useEffect(() => {
    const fetchStateData = async () => {
      try {
        const responseData = await stateApi.fetchData();
        console.log("your state data is", responseData);
        const stateData = responseData.data.states.map((state) => ({
          label: state.name,
          value: state.id,
        }));
        setStateData(stateData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchStateData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchPropertyData = async (pageNumber = 1) => {
    try {
      const responseData = await cityApi.fetchData(pageNumber);
      console.log(responseData);
      setData(responseData.data.cities);
      setTotalPages(responseData.data.totalPage);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchPropertyData(currentPage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState, currentPage]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const initialValues = {};
  const breadcrumbItems = [
    { label: "", link: "/user", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Cities", link: "/city", active: true },
  ];
  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />
          
          <Row>
            <Col lg={12} md={12} sm={12}>
              <Container>
                <Row>
                  <Col lg={9} md={8} sm={12}>
                    <div className="mb-3">
                      <label htmlFor="wish" className="form-label">
                        Select State
                      </label>
                      <Select
                        options={statedata}
                        onChange={setSelectedState}
                        value={selectedState}
                        placeholder="Select State"
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
              {selectedState === null ? (
                <Col>
                  <Container>
                    <p>Please Select The State To Show The City...</p>
                  </Container>
                </Col>
              ) : (
                <>
                  {data?.length === 0 ? (
                    <>
                      <Tr
                        columns={columns}
                        initialValues={initialValues}
                        title="No City Found"
                        buttonName="Create"
                        btnLink="/city/add-city"
                        titleHeader="Cities"
                      />
                      {/* <Row>
                        <Col>
                     
                          <AllMessage title="No City Found" />
                        </Col>
                      </Row>
                      <Col
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        <Link to={"/city/add-city"} className="btn btn-primary">
                          Add City
                        </Link>
                      </Col> */}
                    </>
                  ) : (
                    <List
                      title="Cities"
                      data={data}
                      columns={columns}
                      button="Create"
                      route={`city`}
                      to="add-city"
                      handleDelete={handleDelete}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default City;
